import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconPlusCircleComponent } from "./med-icon-plus-circle.component";

@NgModule({
  declarations: [
    MedIconPlusCircleComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconPlusCircleComponent,
  ],
})
export class MedIconPlusCircleModule { }
